import { render, staticRenderFns } from "./TableExtends.vue?vue&type=template&id=0ab4e5fd&"
import script from "./TableExtends.vue?vue&type=script&lang=js&"
export * from "./TableExtends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TableExtends.vue"
export default component.exports